import AppLayout from 'layout/app-layout';
import { Route, BrowserRouter, Routes, Navigate } from 'react-router-dom';
import { AllRoutes } from './routes';
import Login from './pages/auth';
import NotFound from './components/404';
import { ToastContainer } from 'react-toastify';
import Main from 'pages/home';
import { shallowEqual, useSelector } from 'react-redux';

const App = () => {
  const { user } = useSelector((state: any) => state.auth, shallowEqual);

  const auth = (children: any) => {
    if (user) {
      return <Navigate to={`/`} replace />;
    }

    return children;
  };

  const login = (children: any) => {
    if (!user) {
      return <Navigate to='/login' replace />;
    }
    return children;
  };

  return (
    <BrowserRouter>
      <Routes>
        <Route index path='/login' element={auth(<Login />)} />
        <Route path='' element={login(<AppLayout />)}>
          <Route path='/' element={<Main />} />
          {AllRoutes.map(({ path, component: Component }) => (
            <Route key={path} path={path} element={<Component />} />
          ))}
        </Route>
        <Route path='*' element={<NotFound />} />
      </Routes>
      <ToastContainer
        className='antd-toast'
        position='top-right'
        autoClose={3000}
        hideProgressBar
        closeOnClick
        pauseOnHover
        draggable
      />
    </BrowserRouter>
  );
};
export default App;
